function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React from 'react';
import styled from 'styled-components';
import { isObjectEqual } from '@finect/front-utils/isObjectEqual';
import { uniq } from '@finect/front-utils/uniq';
import { isObject } from '@finect/front-utils/isObject';
import { getProductTypeById } from '@finect/front-resources/Products';
import { objectToArrayOfObjects } from '@finect/front-utils/objectToArrayOfObjects';
import { isArray } from '@finect/front-utils/isArray';
import { productFields } from './entities/product';
import { DefaultComponent } from './ProductRow/DefaultComponent';
import { InlineNoAvailableDataComponent } from './ProductRow/NoAvailableDataComponent';
var TwoLinesCell = styled.div.withConfig({
  displayName: "utils__TwoLinesCell",
  componentId: "sc-j5kng1-0"
})(["line-height:1.25;"]);
export var reduceProductFields = function reduceProductFields(fields, productType) {
  var matchFields = productFields.filter(function (item) {
    return fields.map(function (fieldInput) {
      return fieldInput.id;
    }).includes(item.id);
  }).filter(function (item) {
    return item.productType ? item.productType.includes(productType) : true;
  });
  var tableFields = fields.map(function (fieldObject) {
    return _objectSpread(_objectSpread({}, matchFields.find(function (item) {
      return item.id === fieldObject.id;
    })), {
      params: fields.find(function (item) {
        return isObjectEqual(fieldObject, item);
      })
    });
  });
  return tableFields;
};
var FIELDS_UNIQUEID = ['id', 'metadata', 'feature', 'period', 'fee', 'year', 'breakdown', 'hidden'];
export var parseFields = function parseFields(fields) {
  return fields.map(function (field) {
    if (typeof field === 'string') {
      return {
        id: field,
        uniqueId: field
      };
    }
    return field;
  }).map(function (field) {
    var uniqueId = objectToArrayOfObjects(field).filter(function (item) {
      return FIELDS_UNIQUEID.includes(item.key);
    }).map(function (item) {
      return item.value;
    }).join('-');
    return _objectSpread(_objectSpread({}, field), {}, {
      uniqueId: uniqueId
    });
  });
};
export var isMixedSubtype = function isMixedSubtype(products) {
  return uniq(products.map(function (_ref) {
    var subtype = _ref.subtype;
    return subtype;
  })) > 1;
};
export var getLabel = function getLabel(column, productType, variant) {
  if (typeof column.label === 'string') {
    return column.label;
  }
  if (typeof column.label === 'function') {
    var label = column.label(column.params, productType);
    if (isArray(label)) {
      if (variant === 'cell') {
        var Cell = function Cell() {
          return React.createElement(TwoLinesCell, null, label.map(function (item, key) {
            return React.createElement("div", {
              key: key
            }, item);
          }));
        };
        return React.createElement(Cell, null);
      }
      return label.join(' ');
    }
    return column.label(column.params, productType);
  }
  return '';
};
export var getTooltip = function getTooltip(column, productType) {
  if (isObject(column.tooltip)) {
    return column.tooltip;
  }
  if (typeof column.tooltip === 'function') {
    return column.tooltip(column.params, productType);
  }
  return null;
};
export var getCellTextAlign = function getCellTextAlign(column) {
  var typeAlign = ['number'].includes(column.type) ? 'right' : 'center';
  return column.params && column.params.textAlign ? column.params.textAlign : typeAlign;
};
export var doField = function doField(_ref2) {
  var field = _ref2.field,
    columnIndex = _ref2.columnIndex,
    theme = _ref2.theme,
    productType = _ref2.productType,
    product = _ref2.product,
    model = _ref2.model,
    actions = _ref2.actions,
    productsSubscriptions = _ref2.productsSubscriptions,
    user = _ref2.user;
  var map = field.map,
    _field$defaultParams = field.defaultParams,
    defaultParams = _field$defaultParams === void 0 ? {} : _field$defaultParams,
    _field$props = field.props,
    props = _field$props === void 0 ? field.component ? function (_ref3) {
      var value = _ref3.value;
      return value;
    } : function (_ref4) {
      var value = _ref4.value;
      return {
        value: value
      };
    } : _field$props,
    _field$component = field.component,
    component = _field$component === void 0 ? DefaultComponent : _field$component,
    mapValue = field.mapValue,
    _field$complement = field.complement,
    complement = _field$complement === void 0 ? null : _field$complement;
  var getComplement = function getComplement() {
    if (complement) {
      var parsedFields = parseFields([complement]);
      var columnFields = reduceProductFields(parsedFields, productType.id);
      return columnFields.map(function (complementField, complementColumnIndex) {
        return doField({
          field: complementField,
          columnIndex: complementColumnIndex,
          theme: theme,
          productType: productType,
          product: product,
          model: model,
          actions: actions,
          productsSubscriptions: productsSubscriptions,
          user: user
        });
      });
    }
    return null;
  };
  var additional = getComplement();
  var params = _objectSpread(_objectSpread(_objectSpread({}, defaultParams), field.params), {}, {
    partner: theme.partner
  });
  var value = map ? map(product, params, model) : null;
  var properties = props({
    value: value,
    productType: productType,
    params: params,
    product: product,
    actions: actions,
    productsSubscriptions: {},
    position: 0,
    context: {},
    user: user
  });
  var Component = value ? component : InlineNoAvailableDataComponent;
  var parsedValue = mapValue ? mapValue(product, params, model) : undefined;
  var hasValue = mapValue ? ![null, undefined].includes(parsedValue) : ![null, undefined].includes(value);
  return {
    component: React.createElement(Component, _extends({
      key: "".concat(columnIndex, "-rowIndex"),
      inline: true
    }, properties)),
    value: parsedValue,
    meta: {
      isEmpty: !hasValue,
      additional: additional,
      field: field,
      primaryValue: value,
      column: {
        label: getLabel(field, productType),
        tooltip: getTooltip(field, productType)
      },
      params: params
    }
  };
};
export var getTableCells = function getTableCells(_ref5) {
  var fields = _ref5.fields,
    product = _ref5.product,
    theme = _ref5.theme,
    actions = _ref5.actions,
    productsSubscriptions = _ref5.productsSubscriptions,
    user = _ref5.user;
  var subtype = product.subtype;
  var model = product;
  var productType = getProductTypeById(subtype);
  var parsedFields = parseFields(fields);
  var columnFields = reduceProductFields(parsedFields, subtype);
  return columnFields.map(function (field, columnIndex) {
    return doField({
      field: field,
      columnIndex: columnIndex,
      theme: theme,
      productType: productType,
      product: product,
      model: model,
      actions: actions,
      productsSubscriptions: productsSubscriptions,
      user: user
    });
  });
};
export var getColumns = function getColumns(productType, columnFields, variant) {
  var columns = columnFields.map(function (item) {
    var id = item.id;
    var label = getLabel(item, productType, variant);
    var textAlign = getCellTextAlign(item);
    var tooltip = getTooltip(item, productType);
    return {
      id: id,
      uniqueId: item.params ? item.params.uniqueId : id,
      params: {
        textAlign: textAlign,
        hidden: Boolean(item.params ? item.params.hidden : 0)
      },
      component: label,
      orderable: Boolean(item.mapCompare && item.compare),
      filterable: Boolean(item.mapValue),
      tooltip: tooltip
    };
  });
  return columns;
};
export var CUSTOMIZATION_FIELD_NAME = 'productsTableUXColumns';
export var getCustomization = function getCustomization(fields, productType) {
  try {
    var all = fields.hasOwnProperty(CUSTOMIZATION_FIELD_NAME) ? JSON.parse(fields[CUSTOMIZATION_FIELD_NAME]) : [];
    var match = all.filter(function (item) {
      return Boolean(item);
    }).filter(function (item) {
      return (item.productType || '') === productType && item && item.fields;
    });
    var _match = _slicedToArray(match, 1),
      _match$ = _match[0],
      customization = _match$ === void 0 ? null : _match$;
    return customization;
  } catch (_unused) {
    return null;
  }
};